import React, { FC } from 'react';
import { faAngleUp, faAngleDown, faHistory } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { restrictToNumbersOnly } from '../../utilities/Validation';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';

interface TimeControlProps {
    date: Date;
    incHours: () => void;
    incMins: () => void;
    decHours: () => void;
    decMins: () => void;
    now: () => void;
    onHoursChange?: (value: string) => void;
    onMinutesChange?: (value: string) => void;
}

const TimeControl: FC<TimeControlProps> = ({ date = new Date(), incHours, incMins, decHours, decMins, now, onHoursChange, onMinutesChange }) => {
    const { translate } = useLocale()

    return (
        <div className="w-full p-2">
            <div className="flex flex-row justify-evenly my-1">
                <div className="flex flex-col">
                    <div className="flex flex-row justify-evenly my-1">
                        <button id='incHoursButton' type="button" className="text-gray-700 hover:text-portal-blue-primary" onClick={() => incHours()}>
                            <FontAwesomeIcon fixedWidth icon={faAngleUp} />
                        </button>
                    </div>
                    <div className="flex flex-row justify-evenly my-1 w-8" >
                        <input onChange={onHoursChange ? (e) => onHoursChange(e.target.value) : (e) => { }} className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" value={`0${date.getHours()}`.slice(-2)} onKeyDown={restrictToNumbersOnly} />
                    </div>
                    <div className="flex flex-row justify-evenly my-1">
                        <button type="button" className="text-gray-700 hover:text-portal-blue-primary" onClick={() => decHours()}>
                            <FontAwesomeIcon fixedWidth icon={faAngleDown} />
                        </button>
                    </div>
                </div>

                <div className="flex flex-col justify-center text-gray-500">
                    <p>:</p>
                </div>

                <div className="flex flex-col">
                    <div className="flex flex-row justify-evenly my-1">
                        <button type="button" className="text-gray-700 hover:text-portal-blue-primary" onClick={() => incMins()}>
                            <FontAwesomeIcon fixedWidth icon={faAngleUp} />
                        </button>
                    </div>
                    <div className="flex flex-row justify-evenly my-1 w-8" >
                        <input onChange={onMinutesChange ? (e) => onMinutesChange(e.target.value) : (e) => { }} className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" value={`0${date.getMinutes()}`.slice(-2)} onKeyDown={restrictToNumbersOnly} />
                    </div>
                    <div className="flex flex-row justify-evenly my-1">
                        <button type="button" className="text-gray-700 hover:text-portal-blue-primary" onClick={() => decMins()}>
                            <FontAwesomeIcon fixedWidth icon={faAngleDown} />
                        </button>
                    </div>
                </div>

                <div className="flex flex-col justify-center text-gray-700 text-xs">
                    <div className="flex flex-row justify-start my-1" id='setCurrentTimeButton'>
                        <button type="button" className="text-gray-700 hover:text-portal-blue-primary" onClick={() => now()}>
                            <FontAwesomeIcon icon={faHistory} /> {translate.byKey(TranslationKeys.now)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimeControl;
